import { AttachmentIcon } from "@chakra-ui/icons";
import React from "react";
import Footer from "../components/Footer";

const Games = () => {
  return (
    <>
    <div className="pt-[100px]  animate__animated  animate__backInRight  ">
          <img
            className="h-full w-full object-contain "
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fgaming_headings.7e672c6f.png&w=1920&q=75"
            alt="game_img"
          />
       </div>
      <div className="p-[5%]">
       
        <div
          id="game__1st__content"
          className="flex items-center justify-center p-[5%] max-md:flex-col max-md:p-[8%] animate__animated animate__backInUp"
        >
          <div className="w-[40%] max-md:w-full ">
            <img
              className="h-full w-[full] object-contain"
              src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fgaming_headings_imgs.a0ac5101.png&w=828&q=75"
              alt="game_img2"
            />
          </div>
          <div className="w-[60%] max-md:w-full">
            <h1 className="pb-3 text-[36px] text-[#157a70] max-md:text-[20px]">
              THE WORLD OF INNOVATION WITH PUZZLE GAME
            </h1>
            <div className="space-y-2 text-start text-[16px] max-md:text-[13px] ">
              <div className="flex space-x-2">
                <i>
                  <AttachmentIcon />
                </i>
                <p>
                  Passion is showcased through meticulously crafted artwork and
                  engaging gameplay in our puzzle game. With a focus on
                  delivering the best possible experience for our players, we
                  pay attention into every detail.
                </p>
              </div>

              <div className="flex space-x-2">
                <i>
                  <AttachmentIcon />
                </i>
                <p>
                  Our game seamlessly blends classic gameplay with modern
                  twists, delivering a captivating experience that captivates
                  players worldwide. The innovation lies in the fun and
                  challenging puzzles that have propelled its success.
                </p>
              </div>

              <div className="flex space-x-2">
                <i>
                  <AttachmentIcon />
                </i>
                <p>
                  More than 2 millions of delighted players from across the
                  globe have experienced the excitement of the authentic
                  ‘Traffic Jam Cars Puzzle’ game.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="game__1st__content"
        className="flex h-[300px] w-full items-center justify-between bg-[#262730] p-[3%] max-md:h-full max-md:flex-col  "
      >
          <div className="flex w-[30%] flex-col items-center gap-2 p-[5%] text-center max-md:w-full  ">
            <img
              className="h-[5vh] max-h-full max-w-full object-contain max-md:w-[50%]"
              src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fgaming_details_icons1.29504e68.png&w=256&q=75"
              alt="app_img"
            />

            <h1 className="text-xl text-white">Intuitive user interface</h1>
            <h4 className="text-sm text-[#8bb7c4]">
              Users can navigate the game with ease and concentrate fully on the
              action
            </h4>
          </div>

          <div  
          className="flex w-[30%] flex-col items-center gap-2  p-[5%] text-center max-md:w-full">
            <img
              className="h-[5vh] max-h-full max-w-full object-contain"
              src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fgaming_details_icons2.e91c48fd.png&w=384&q=75"
              alt="app_img"
            />
            <h1 className="text-xl text-white">
              Entertaining and challenging gameplay
            </h1>
            <h4 className="text-sm text-[#8bb7c4]">
              A well-balanced difficulty curve keeps users engaged and motivated
            </h4>
          </div>

          <div className="flex w-[30%] flex-col items-center gap-2 p-[5%] text-center max-md:w-full">
            <img
              className="h-[5vh] max-h-full max-w-full object-contain"
              src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fgaming_details_icons3.497a7f9d.png&w=256&q=75"
              alt="app_img"
            />
            <h1 className="text-xl text-white">User insights</h1>
            <h4 className="text-sm text-[#8bb7c4]">
              We understand our targeted users and value every user is review,
              driving our continuous product optimization
            </h4>
          </div>
      </div>

      <div id="game___1st__product"
        className="mx-[3%] flex flex-row space-x-10 p-[5%] text-[#6b6b6b] max-md:flex-col max-md:gap-5"
      >
        <div className="flex w-[60%] flex-col gap-4 max-md:w-full ">
          <h1 className="text-[36px] font-semibold text-[#157a70] max-md:text-[20px]">
            TRAFFIC JAM CARS PUZZLE
          </h1>
          <p className="text-[18px] max-md:text-[12px]">
            Traffic Jam Cars Puzzle is a strategic and classic puzzle game that
            seamlessly blends engaging and challenging gameplay. Players engage
            in logical puzzle-solving while deciding their moves to overcome
            traffic obstacles and achieve victory.
          </p>
          <div className="flex flex-col gap-2 pl-12 ">
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[18px] max-md:text-[9px] ">
                Earning an impressive spot among the top 100 highest-grossing
                mobile games across 53 countries, including rankings of #50 in
                Japan, #150 in Germany, #80 in the United States, #150 in Great
                Britain, and #200 in South Korea, speaks volumes of its global
                appeal and revenue potential.
              </p>
            </div>
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[18px] max-md:text-[9px]">
                Earning an impressive spot among the top 100 highest-grossing
                mobile games across 53 countries, including rankings of #50 in
                Japan, #150 in Germany, #80 in the United States, #150 in Great
                Britain, and #200 in South Korea, speaks volumes of its global
                appeal and revenue potential.
              </p>
            </div>
          </div>
          <div id="game__button" className=" mt-3 flex w-full flex-row gap-7 ">
            <a
              className="transition delay-150 duration-300  ease-in-out hover:-translate-y-1  hover:scale-110"
              href="https://apps.apple.com/vn/app/traffic-jam-cars-puzzle-2022/id1600852359"
            >
              <img
                className="[182px] h-[53px] cursor-pointer transition delay-150 ease-in-out hover:border-spacing-3 hover:shadow-xl "
                src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ficons_appstore.e2839cb0.png&w=256&q=75"
                alt="button"
              />
            </a>

            <a
              className="transition delay-150 duration-300  ease-in-out hover:-translate-y-1  hover:scale-110"
              href="https://play.google.com/store/apps/details?id=com.gametamin.trafficjamcarspuzzle"
            >
              <img
                className="h-[53px] w-[182px] cursor-pointer  hover:border-spacing-3 hover:shadow-xl"
                src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ficons_chplay.50904995.png&w=256&q=75"
                alt="button"
              />
            </a>
          </div>
        </div>

        <div>
          <img
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fgame_banner_game1.3659d554.png&w=640&q=75"
            alt="img"
          />
        </div>
      </div>

      <div id="game___2nd__product"
        className="mx-[3%] flex flex-row-reverse gap-[40px] p-[5%] text-[#6b6b6b] max-xl:flex-col max-md:gap-5"
      >
        <div className="flex w-[60%] flex-col gap-4 max-lg:w-full max-md:w-full max-sm:w-full ">
          <h1 className="text-[36px] font-semibold text-[#157a70]  max-lg:text-[20px] max-md:text-[20px]">
            TRAFFIC JAM CARS PUZZLE
          </h1>
          <p className="text-[18px] max-lg:text-[12px] max-md:text-[12px]">
            Traffic Jam Cars Puzzle is a strategic and classic puzzle game that
            seamlessly blends engaging and challenging gameplay. Players engage
            in logical puzzle-solving while deciding their moves to overcome
            traffic obstacles and achieve victory.
          </p>
          <div className="flex flex-col gap-2 pl-12 ">
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[18px] max-lg:text-[9px] max-md:text-[9px] ">
                Earning an impressive spot among the top 100 highest-grossing
                mobile games across 53 countries, including rankings of #50 in
                Japan, #150 in Germany, #80 in the United States, #150 in Great
                Britain, and #200 in South Korea, speaks volumes of its global
                appeal and revenue potential.
              </p>
            </div>
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[18px] max-lg:text-[9px] max-md:text-[9px] ">
                Earning an impressive spot among the top 100 highest-grossing
                mobile games across 53 countries, including rankings of #50 in
                Japan, #150 in Germany, #80 in the United States, #150 in Great
                Britain, and #200 in South Korea, speaks volumes of its global
                appeal and revenue potential.
              </p>
            </div>
          </div>
          <div id="game__button" className=" mt-3 flex w-full flex-row gap-7 ">
            <a
              className="transition delay-150 duration-300  ease-in-out hover:-translate-y-1  hover:scale-110"
              href="https://apps.apple.com/vn/app/traffic-jam-cars-puzzle-2022/id1600852359"
            >
              <img
                className="[182px] h-[53px] cursor-pointer transition delay-150 ease-in-out hover:border-spacing-3 hover:shadow-xl "
                src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ficons_appstore.e2839cb0.png&w=256&q=75"
                alt="button"
              />
            </a>

            <a
              className="transition delay-150 duration-300  ease-in-out hover:-translate-y-1  hover:scale-110"
              href="https://play.google.com/store/apps/details?id=com.gametamin.solitaire.harvest.tripeaks.farm"
            >
              <img
                className="h-[53px] w-[182px] cursor-pointer  hover:border-spacing-3 hover:shadow-xl"
                src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ficons_chplay.50904995.png&w=256&q=75"
                alt="button"
              />
            </a>
          </div>
        </div>

        <div className="max-lg:w-full max-lg:items-center max-md:w-full max-sm:w-full">
          <img
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fgame_banner_game2.4f38caf5.png&w=640&q=75"
            alt="img"
          />
        </div>
      </div>

      <div id="game___3rd__product"
        className="mx-[3%] flex flex-row space-x-10 p-[5%] text-[#6b6b6b] max-md:flex-col max-md:gap-5"
      >
        <div className="flex w-[60%] flex-col gap-4 max-md:w-full ">
          <h1 className="text-[36px] font-semibold text-[#157a70] max-md:text-[20px]">
            SOLITAIRE JOURNEY OF HARVEST
          </h1>
          <p className="text-[18px] max-md:text-[12px]">
            Solitaire Journey of Harvest masterfully fuses the serenity of
            Tripeak solitaire gameplay with the engaging allure of farm
            simulation. The gentle melodies and beautiful artworks become an
            integral part of the overall experience.
          </p>
          <div className="flex flex-col gap-2 pl-12 ">
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[18px] max-md:text-[9px] ">
                Solitaire Journey of Harvest artfully blends the therapeutic
                quality of Solitaire with an addictive gameplay loop. Users can
                construct houses and nurture crops as they progress through
                levels.
              </p>
            </div>
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[18px] max-md:text-[9px]">
                The game envelops users in a visually stunning landscape, where
                lush farms and charming cottages come to life through vivid
                graphics. This meticulous attention to detail enhances the
                overall immersion, creating an aesthetic marvel that appeals to
                gamers seeking an aesthetically pleasing experience.
              </p>
            </div>
          </div>
          <div id="game__button" className=" mt-3 flex w-full flex-row gap-7 ">
            <a
              className="transition delay-150 duration-300  ease-in-out hover:-translate-y-1  hover:scale-110"
              href="https://apps.apple.com/vn/app/solitaire-journey-of-harvest/id1638054336"
            >
              <img
                className="[182px] h-[53px] cursor-pointer transition delay-150 ease-in-out hover:border-spacing-3 hover:shadow-xl "
                src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ficons_appstore.e2839cb0.png&w=256&q=75"
                alt="button"
              />
            </a>

            <a
              className="transition delay-150 duration-300  ease-in-out hover:-translate-y-1  hover:scale-110"
              href="https://play.google.com/store/apps/details?id=com.gametamin.solitaire.harvest.tripeaks.farm"
            >
              <img
                className="h-[53px] w-[182px] cursor-pointer  hover:border-spacing-3 hover:shadow-xl"
                src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ficons_chplay.50904995.png&w=256&q=75"
                alt="button"
              />
            </a>
          </div>
        </div>

        <div>
          <img
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fgame_banner_game3.c51363b3.png&w=640&q=75"
            alt="img"
          />
        </div>
      </div>

      <div id="game___4th__product"
        className="mx-[3%] flex flex-row-reverse gap-10 space-x-10 p-[5%] text-[#6b6b6b] max-md:flex-col max-md:gap-5"
      >
        <div className="flex w-[60%] flex-col gap-4 max-md:w-full ">
          <h1 className="text-[36px] font-semibold text-[#157a70] max-md:text-[20px]">
            ANIMAL FARM JAM
          </h1>
          <p className="text-[18px] max-md:text-[12px]">
            Animal Farm Jam features a unique 3D rendering approach, merging
            animal and farm themes with the classic unblock and parking game
            mechanics. This adorable game creates a fresh gameplay experience
            that appeals to both new and seasoned players. The incorporation of
            3D visuals and farm simulation revitalizes the traditional concept,
            making it a wonderful gaming adventure.
          </p>

          <div id="game__button" className=" mt-3 flex w-full flex-row gap-7 ">
            <a
              className="transition delay-150 duration-300  ease-in-out hover:-translate-y-1  hover:scale-110"
              href="https://apps.apple.com/us/app/animal-farm-jam-parking-game/id6446186498"
            >
              <img
                className="[182px] h-[53px] cursor-pointer transition delay-150 ease-in-out hover:border-spacing-3 hover:shadow-xl "
                src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ficons_appstore.e2839cb0.png&w=256&q=75"
                alt="button"
              />
            </a>

            <a
              className="transition delay-150 duration-300  ease-in-out hover:-translate-y-1  hover:scale-110"
              href="https://play.google.com/store/apps/details?id=com.vjctory.farmjam.animalfarm"
            >
              <img
                className="h-[53px] w-[182px] cursor-pointer  hover:border-spacing-3 hover:shadow-xl"
                src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ficons_chplay.50904995.png&w=256&q=75"
                alt="button"
              />
            </a>
          </div>
        </div>

        <div>
          <img
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fgame_banner_game4.12475303.png&w=640&q=75"
            alt="img"
          />
        </div>
      </div>

      <div id="game__last__content" className="mb-[60px] p-[5%] ">
        <h1 className="text-[30px] text-[#157a70]">NEWS</h1>

        <div className="flex flex-row gap-10 max-md:flex-col max-md:space-y-24 max-sm:flex-col ">
          <div
            id="game__last__content__left"
            className="flex h-[400px] w-[50%] flex-col gap-5 max-md:w-full"
          >
            <img
              className="h-full w-full object-contain"
              src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fapp_news_img1.a12aadfa.png&w=750&q=75"
              alt="app_img"
            />
            <h1 className="text-[24px] text-[#157a70]">
              Factors influence app rankings on the Google Play Store
            </h1>
            <p className="text-[16px] text-[#6b6b6b]">
              The Google Play Store app rankings are shaped by a range of
              influential factors. From user engagement to app quality, these
              elements collectively impact an app is visibility and success.
              Grasping these dynamics is vital for developers and marketers
              aiming to enhance their app is reach and appeal.
            </p>
          </div>

          <div
            id="game__last__content_right"
            className="flex h-[400px] w-[50%] flex-col gap-5 max-md:w-full"
          >
            <img
              className="h-full w-full object-contain"
              src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fapp_news_img2.2a77398c.png&w=750&q=75"
              alt="app_img"
            />
            <h1 className="text-[24px] text-[#157a70]">
              Top 10 farm games for creative inspiration
            </h1>
            <p className="text-[16px] text-[#6b6b6b]">
              The internet hosts a vast array of gaming categories catering to
              various preferences and time-killing pursuits. Among these
              categories, farming games stand out due to their diverse features
              and captivating options that maximize leisure time. These games
              are thoughtfully designed to emulate genuine farming experiences,
              encompassing a spectrum of tasks integral to agricultural life.
            </p>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default Games;
